module.exports = __webpack_public_path__ + "static/media/gesivid_branco.7705e6f0.png";